import { FlagsContextModel } from 'config/useFlagsContext'
import { isCboNivelSuperior } from 'types/NivelCbo'

export const canRegisterCid10 = (cbo2002: string): boolean => {
  return isCboNivelSuperior(cbo2002)
}

export const getIsVinculacaoCuidadoAtiva = (flags: FlagsContextModel, isAtendimentoOdonto: boolean): boolean => {
  const pilotoVinculacaoCuidadoOdontoAtivo =
    flags.PILOTO_VINCULACAO_CUIDADO_ENABLED && flags.PILOTO_VINCULACAO_CUIDADO_ODONTO_ENABLED
  return isAtendimentoOdonto ? pilotoVinculacaoCuidadoOdontoAtivo : flags.PILOTO_VINCULACAO_CUIDADO_ENABLED
}
